export class SellersRequest {
    
    sellerCode: string;
}